import { typedQueryClient, useTypedMutation } from "hooks";
import { AppointmentDetailsKeys } from "modules/AppointmentDetails/queryKeys";
import { ApiInstance } from "utils/Api";

type StarIndicatorPayload = { is_star: boolean; is_star_color: string };

export const useAppointmentStarIndicatorMutation = (appointment_id: number) =>
  useTypedMutation<StarIndicatorPayload, void>({
    mutationFn: async payload => {
      await ApiInstance.post("/appointments/update_star", { appointment_id, ...payload });
    },
    onSuccess: payload => {
      const appointment = typedQueryClient.getQueryData(AppointmentDetailsKeys.view);
      if (!appointment) return;

      typedQueryClient.setQueryData(AppointmentDetailsKeys.view, { ...appointment, ...payload });
    }
  });
